

































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import RequestButton from '@/components/RequestButton'
import RecessAPI from '@services/RecessAPI'
import BrandRepInfoStep from './BrandRepInfoStep'
# import SubmitWizardTriggerModal from '@triggers/BrandRepWizard/SubmitWizardTriggerModal'

settings =
  name: 'BrandRepCreateWizard'

  resources:
    new_brand_rep:
      resourceName: 'brand_rep'
      slug: 'magic_brand_reps'
      fetch: false

  vue:
    mixins: [WizardService.wizard()]

    components: {
      RequestButton,
      BrandRepInfoStep,
    }

    data: ->
      brandRepInfo:
        email: ''

    created: ->
      @$router.replace({ name: 'CampaignCreatePage' }) if @partnerBuy?.brandRep

    computed:
      partnerBuy: -> @getAppSession 'partnerBuy' || {}

      canSubmit: ->
        return false if 0 is @brandRepInfo.email.length
        @partnerBuy.bookings ||= {}
        listingIds = Object.keys(@partnerBuy.bookings)
        0 isnt listingIds.length

    methods:
      hiSubmitWizardTrigger: ->
        @validateActiveStep()
        return unless @stepIsValid()
        payloadOptions =
          brand_rep_info: @brandRepInfo
          audience_partnership_token: @partnerBuy?.token
        @triggerResource 'new_brand_rep', 'create_brand_rep', payloadOptions

      onNewBrandRepCreateBrandRep: (data, brandRep) ->
        partnerBuy = @storePartnerBuy brandRep
        RecessAPI.configureAppForPartnerBuy partnerBuy
        @$router.push({ name: 'CampaignCreatePage' })

      storePartnerBuy: (brandRep) ->
        partnerBuy = @getAppSession 'partnerBuy'
        partnerBuy.brandRep = brandRep
        @setAppSession 'partnerBuy', partnerBuy
        partnerBuy

export default VueOptions.vue settings
